<template>
    <b-modal
          size="md"
          :hideFooter="true"
          :hideHeader="true"
          hide-backdrop
          no-fade
          id="notificationsModal"
          modal-class="notificationsModal"
          body-class="p-0"
          @show="onShow"
    >
      <template slot="default">
        <div class="notificationsModal__header">
          <h6>
            Ваши уведомления
          </h6>
        </div>
        <div v-if="nots.length > 0" class="notificationsModal__notificationsContainer">
          <b-list-group>
            <b-list-group-item :class="note.isRead ? '' : 'notification-unread'" class="notificationsModal__notification" v-for="(note, index) in limitedNotes" :key="index">
              <div v-html="note.text"></div>
              <span class="notifications__notificationDatetime">
                {{ note.createdAt | moment('HH:mm:ss, DD MMMM') }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div v-else class="notificationsModal__notificationsEmptyContainer">
          <p>
            Уведомления отсутствуют
          </p>
        </div>
        <b-row class="notificationsModal__row-btn">
          <b-button @click="onGoToAllNotificationsClick" class="notificationsModal__showAllButton" :disabled="nots.length < 1" squared variant="primary">
            Показать все <span v-if="unreadNots > 0">({{ unreadNots }})</span>
          </b-button>
        </b-row>
      </template>
    </b-modal>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

import notesApi from '@/api/notifications'

export default {
  name: 'NotificationsModal',
  data() {
    return {
    }
  },
  computed: {
    limitedNotes() {
      return this.nots.slice(0, 5)
    },
    ...mapGetters('notifications', {
      nots: 'getLatestNots',
      unreadNots: 'getUnreadNots'
    })
  },
  methods: {
    onClose() {
      this.$bvModal.hide('notificationsModal')
    },
    onGoToAllNotificationsClick() {
      this.$bvModal.hide('notificationsModal')
      this.$router.push({ name: 'NotificationsPage' })
    },
    onShow() {
      notesApi.notificationsMakeRead(this.limitedNotes.filter((el) => el.isRead === false).map((el) => el.id))
        .then(() => {
          this.fetchLatestNots()
          this.fetchUnreadNots()
          this.fetchNots()
        })
    },
    ...mapActions('notifications', [
      'fetchLatestNots',
      'fetchUnreadNots',
      'fetchNots'
    ])
  }
}
</script>

<style>

.notificationsModal > div {
  float: right;
  position: fixed !important;
  top: 50px;
  right: 45px;
  width: 300px;
}


.notificationsModal__header {
  height: 50px;
  width: 100%;
  margin-bottom: -1px;
  border-bottom: 1px solid lightgray;
  z-index: 1;
  display: inline-flex;
  align-items: center;
}

.notificationsModal__header h6 {
  font-weight: 600;
  margin-bottom: 0;
  padding: 10px;
}

.notificationsModal__header span {
  position: absolute;
  right: 10px;
  color: grey;
}

.notificationsModal__header__closeIcon {
  cursor: pointer;
}

.notificationsModal__notificationsContainer {
  height: 300px !important;
  overflow-y: scroll;
  overflow-x: hidden;
}

.notificationsModal__notificationsEmptyContainer {
  color: gray;
  font-weight: 500;
  text-align: center;
  padding-top: 15px;
}

.notificationsModal__notification {
  font-size: 0.85em;
  padding: 20px;
}

.notifications__notificationDatetime {
  color: grey;
  font-size: 0.8em;
}

.notificationsModal__row-btn {
  margin: 0 auto;
}

.notificationsModal__showAllButton {
  width: 100%;
}

.fa-thumbs-up {
  color: #28a745;
}

.fa-thumbs-down {
  color: #dc3545;
}

@media only screen and (max-width : 991px) {
  .notificationsModal > div {
    right: 120px;
  }
}

@media only screen and (max-width : 575px) {
  .notificationsModal > div {
    top: 46px;
  }
}

@media only screen and (max-width: 400px) {
  .notificationsModal > div {
    right: 0;
  }
}
</style>
